import styles, { css, keyframes } from 'styled-components';

export const removeButtonStyles = css`
    border: 0;
    padding: 0;
    font-family: inherit;
    font-weight: normal;
    background-color: unset;
    outline: none;
`;

export const BaseButton = styles.button`
    ${removeButtonStyles};
    cursor: pointer;
    font-weight: bold;
    border-radius: 4px;
    padding: 10px 16px;
    min-width: 90px;
    box-sizing: border-box;
`;

const clickAnimation = keyframes`
    0% {
        transform: scale(1);
        border-radius: 4px;
    }

    50% {
        transform: scale(1.01);
    }

    75% {
        transform: scale(0.99);
    }

    100% {
        transform: scale(1);
    }
`;

const createHoverableButton = (backgroundColor, hoverColor, inverted) => {
  return (
    styles(BaseButton)`
            background-color: ${backgroundColor};
            color: ${inverted ? 'white' : 'black'};
            &:hover {
                background-color: ${hoverColor};
                animation: ${props => props.animated ? css`${clickAnimation} 0.25s ease-in-out` : undefined};
            }
        `
  );
};

export const PrimaryButton = createHoverableButton(
  '#19aaee',
  '#33bbff',
  true,
);

export const SecondaryButton = createHoverableButton(
  '#d5d7d7',
  '#edf0f2',
  false,
);

export const ContrastButton = createHoverableButton(
  '#7d2ae8',
  '#8d39fa',
  true,
);

export const ConfirmButton = createHoverableButton(
  'rgb(38, 137, 12)',
  'rgb(35, 126, 11)',
  true,
);

export const EndButton = createHoverableButton(
  'rgb(220, 0, 78)',
  'rgb(154, 0, 54)',
  true,
);

export const BorderButton = styles(BaseButton)`
  border: solid 1px rgb(51, 51, 51);
  background-color: white;
  color: black;
  &:hover {
      opacity: 0.6;
      animation: ${props => props.animated ? css`${clickAnimation} 0.25s ease-in-out` : undefined};
  }
`;

export const WhiteButton = createHoverableButton(
  'white',
  '#f0f0f0',
  false,
);
